import {
  getPaginationRowModel,
  getFilteredRowModel,
  ColumnFiltersState,
  getSortedRowModel,
  getCoreRowModel,
  PaginationState,
  useReactTable,
  SortingState,
} from '@ui/components';
import { getInvoiceRecipients } from '@api/invoice';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { useInvoiceRecipientsTableColumns } from './use-invoice-recipients-table-columns';

interface InvoiceRecipientsTableProps {
  invoiceId: string;
}

export const useInvoiceRecipientsTable = ({ invoiceId }: InvoiceRecipientsTableProps) => {
  const [tableSearchQuery, setTableSearchQuery] = useState('');
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [rowSelection, setRowSelection] = useState({});
  const [sorting, setSorting] = useState<SortingState>([]);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 15,
  });

  const columns = useInvoiceRecipientsTableColumns();

  const { data: invoiceRecipients, isLoading: isLoadingInvoiceRecipients } = useQuery({
    queryFn: () => getInvoiceRecipients(invoiceId),
    queryKey: ['invoice-recipients', invoiceId],
  });

  const table = useReactTable({
    getRowId: (row) => row.id as unknown as string,
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    state: { pagination, sorting, globalFilter: tableSearchQuery, columnFilters, rowSelection },
    onGlobalFilterChange: setTableSearchQuery,
    onColumnFiltersChange: setColumnFilters,
    onRowSelectionChange: setRowSelection,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    data: invoiceRecipients ?? [],
    columns: columns,
  });

  return {
    isLoading: isLoadingInvoiceRecipients,
    totalItems: invoiceRecipients?.length,
    columnsLength: columns.length,
    data: invoiceRecipients,
    table,
  };
};
